import { Injectable } from '@angular/core';
import {
  Auth,
  getIdTokenResult,
  onAuthStateChanged,
  user,
} from '@angular/fire/auth';
import {
  CanActivate,
  Router
} from '@angular/router';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { environment } from '../../../src/environments/environment';

export enum Role {
  ADMIN = 'Admin',
  OTT = 'OTT',
  CSM = 'CSM',
  FINANCE = 'Finance',
  TECH = 'Tech',
  SALES = 'Sales',
}

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  userRole!: Role;
  userToken: string | undefined;
  userDocId = '';
  environmentName: string = environment.name;

  constructor(private readonly auth: Auth, private readonly router: Router) {
    onAuthStateChanged(this.auth, (user) => {
      if (user) {
        getIdTokenResult(user).then((result) => {
          this.userToken = result.token;
          this.userRole = result.claims?.role as Role;
        });
      }
    });
  }

  canActivate(): Observable<boolean> {
    return user(this.auth).pipe(
      first(),
      map((authUser) => {
        if (authUser) {
          localStorage.setItem('userSession', JSON.stringify(authUser));
          this.userDocId = authUser.uid;
          return true;
        } else {
          this.router.navigate(['/login']);
          return false;
        }
      })
    );
  }
}
